const quickView = {};
quickView.first_load = true;

$(document).ready(function () {
  function ajax(options) {
    return new Promise(function (resolve, reject) {
      $.ajax(options).done(resolve).fail(reject);
    });
  }

  $("body").delegate(
    'fieldset.quickview-form__input input[type="radio"]',
    "change",
    function () {
      $(this).parents("fieldset").find("label").removeClass("selected");

      $(this)
        .parents("fieldset")
        .find(".variant__label-info span")
        .html($(this).val());
      $(this).parents(".option-swatch").find("label").addClass("selected");
      var select_img = $(this)
        .parents(".variant-input.option-swatch")
        .attr("image-src");

      if (select_img != "undefined" && select_img != "") {
        $(this)
          .parents(".quick-view-model")
          .find(".quick-view_image img")
          .attr("src", select_img);
      }
    }
  );

  $("body").delegate(".quick_view_btn.enabled", "click", function (e) {
    var $self = $(this);
    $self.removeClass("enabled");

    var selected_color = $(this)
      .closest(".card-wrapper")
      .find(".grid-variant-input input:checked")
      .next()
      .attr("value");

    let product = $(this).data("product");
    var pathname = window.location.pathname;
    var lang = pathname.split("/")[1];
    if (lang.length === 2) {
      var url = `/${lang}/products/${product}?view=quick-view`;
    } else {
      var url = `/products/${product}?view=quick-view`;
    }
    ajax({
      type: "GET",
      url: url,
      beforeSend: function () {
        $("#quick-view").show();
        $(".loader-quickview").show();
        document.getElementById("quick-view").dataset.productHandle = product;
      },
      dataType: "html",
    })
      .then(
        function fulfillHandler(data) {
          $(".loader-quickview").hide();
          var filteredData = $(data).find(".quick-view_grid");
          $("#quick-view .modal-content").append(filteredData);

          $(`#quick-view .modal-content [value='${selected_color}']`).click();
          $("#quick-view").show();
          $("#quick-view").addClass("active_quickView");

          $self.addClass("enabled");
          setTimeout(function () {
            getFocusableElements(document.querySelector(".quick-view-model"));
            trapFocus(
              document.querySelector(".quick-view-model"),
              document.querySelector(".modal-content .close")
            );
            $(".size__chart-trigger").each(function (sizeChartTrigger) {
              fireClickOnEnterKeydown($(this)[0]);
            });
          }, 300);
          // Init slider
          if (document.querySelector("#quick-view .product-slider-main")) {
            quickView.flickity = new theme.Slideshow(
              document.querySelector("#quick-view .product-slider-main"),
              {
                adaptiveHeight: true,
                avoidReflow: true,
                lazyLoad: 1,
                pageDots: false,
                prevNextButtons: true,
                wrapAround: true,
                contain: false,
                callbacks: {
                  onChange: onSlideChange.bind(this),
                },
              }
            );
            setTimeout(function () {
              flkty.resize();
            }, 100);
            var mainSlider = document.querySelector(
              "#quick-view .product-slider-main"
            );
            flkty = quickView.flickity.slideshow;
            document
              .querySelectorAll(".shopify-model-viewer-ui__button.close")
              .forEach((item) => {
                item.addEventListener("click", function () {
                  const model = item
                    .closest(".product-image-main")
                    .querySelector("model-viewer");
                  flkty.options.draggable = true;
                  flkty.updateDraggable();
                  model.classList.add("disable");
                });
              });
            if (
              document.querySelectorAll(
                ".shopify-model-viewer-ui__controls-overlay button"
              )
            ) {
              document
                .querySelectorAll(
                  ".shopify-model-viewer-ui__controls-overlay button"
                )
                .forEach((item) => {
                  item.addEventListener("click", function () {
                    const model = item
                      .closest(".product-image-main")
                      .querySelector("model-viewer");
                    if (model.classList.contains("disable")) {
                      model.classList.remove("disable");
                      flkty.options.draggable = false;
                      flkty.updateDraggable();
                    }
                  });
                });
            }
            function onSlideChange() {
              // Stop all videos
              stopVideos();
              if (mainSlider.querySelectorAll("video")) {
                mainSlider.querySelectorAll("video").forEach((video) => {
                  video.pause();
                });
              }
              if (document.querySelectorAll("iframe")) {
                document
                  .querySelectorAll("lite-youtube iframe")
                  .forEach((iframe) => {
                    iframe.contentWindow.postMessage(
                      JSON.stringify({ event: "command", func: "stopVideo" }),
                      "*"
                    );
                  });
                document.querySelectorAll(".js-vimeo").forEach((video) => {
                  video.contentWindow.postMessage('{"method":"pause"}', "*");
                });
              }
              const currentSlideIndex = quickView.flickity.slideshow.selectedIndex;
              // Autoplay video
              // if (
              //   mainSlider.querySelector(
              //     '.product-main-slide[data-index="' +
              //       currentSlideIndex +
              //       '"]'
              //   )
              // ) {
              //   if (
              //     mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector("video")
              //   ) {
              //     playMp4(mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector("video"));
              //     function playMp4(video, container) {
              //       if (video.classList.contains("lazyloaded")) {
              //         video.play();
              //         video
              //           .closest(".product-single__media")
              //           .classList.add("playing");
              //       } else {
              //         setTimeout(() => {
              //           playMp4(video, container);
              //         }, 200);
              //       }
              //     }
              //   }
              //   if (
              //     mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector("lite-youtube")
              //   ) {
              //     setTimeout(() => {
              //       mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector("lite-youtube")
              //         .click();
              //     }, 50);
              //   }
              //   if (
              //     mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector("lite-youtube iframe")
              //   ) {
              //     setTimeout(() => {
              //       mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector("lite-youtube iframe")
              //         .contentWindow.postMessage(
              //           JSON.stringify({ event: "command", func: "playVideo" }),
              //           "*"
              //         );
              //       mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector(".product-single__media")
              //         .classList.add("playing");
              //     }, 50);
              //   }
              //   if (
              //     mainSlider
              //       .querySelector(
              //         '.product-main-slide[data-index="' +
              //           currentSlideIndex +
              //           '"]'
              //       )
              //       .querySelector(".js-vimeo")
              //   ) {
              //     setTimeout(() => {
              //       mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector(".js-vimeo")
              //         .contentWindow.postMessage('{"method":"play"}', "*");
              //       mainSlider
              //         .querySelector(
              //           '.product-main-slide[data-index="' +
              //             currentSlideIndex +
              //             '"]'
              //         )
              //         .querySelector(".product-single__media")
              //         .classList.add("playing");
              //     }, 50);
              //   }
              // }
            }
          }
          // Load model viewer
          if (
            document.querySelector("#quick-view model-viewer") &&
            !document.querySelector("script#model-viewer-loaded")
          ) {
            const body = document.body;
            let loaded = !1;
            var src = document
              .querySelector("#quick-view script#model-viewer")
              .getAttribute("data-src");
            const onInteraction = () => {
              if (!0 === loaded) return;
              loaded = !0;
              let e = document.createElement("script");
              (e.type = "module"),
                (e.src = src),
                (e.id = "model-viewer-loaded"),
                body.appendChild(e);
            };
            body.addEventListener("mouseover", onInteraction, { once: !0 }),
              body.addEventListener("touchmove", onInteraction, { once: !0 }),
              body.addEventListener("scroll", onInteraction, { once: !0 }),
              body.addEventListener("keydown", onInteraction, { once: !0 });
            const onProgress = (e) => {
              let t = e.target.querySelector(".progress-bar");
              (e.target.querySelector(".update-bar").style.width = `${
                100 * e.detail.totalProgress
              }%`),
                1 == e.detail.totalProgress && t.classList.add("hide");
            };
            document.querySelectorAll("model-viewer").forEach((item) => {
              item.addEventListener("progress", onProgress);
            });
          }
          // Load lite youtube
          if (document.querySelector("#quick-view lite-youtube")) {
            var lite_youtube_src = document
              .querySelector("#quick-view script#lite-youtube")
              .getAttribute("data-src");
            var lite_youtube_script = document.createElement("script");
            lite_youtube_script.src = lite_youtube_src;
            document.head.appendChild(lite_youtube_script);
          }
        },
        function rejectHandler(jqXHR, textStatus, errorThrown) {}
      )
      .catch(function errorHandler(error) {});
  });

  $("#quick-view").click(function (event) {
    if (
      !$(event.target).closest(".quick-view-model").length &&
      !$(event.target).is(".quick-view-model")
    ) {
      $("#quick-view").removeClass("active_quickView");
      setTimeout(function () {
        $("#quick-view .quick-view_grid").remove();
        $("#quick-view").hide();
      }, 800);
    }
  });

  $(document).on(
    "click",
    ".modal-content .quick-view_close .close",
    function () {
      $("#quick-view").removeClass("active_quickView");
      setTimeout(function () {
        $("#quick-view .quick-view_grid").remove();
        $("#quick-view").hide();
      }, 800);
    }
  );
});

var stopVideos = function () {
  var videos = document.querySelectorAll(
    "lite-vimeo, lite-youtube iframe, video"
  );
  Array.prototype.forEach.call(videos, function (video) {
    if (video.tagName.toLowerCase() === "video") {
      video.pause();
    } else if (video.tagName.toLowerCase() === "iframe") {
      /* pause youtube embeds */
      video.contentWindow.postMessage(
        '{"event":"command","func":"stopVideo","args":""}',
        "*"
      );
    } else if (video.tagName.toLowerCase() === "lite-vimeo") {
      if (!!document.querySelector("lite-vimeo").shadowRoot) {
        if (
          !!document
            .querySelector("lite-vimeo")
            .shadowRoot.querySelector("iframe")
        ) {
          var videoIframe = video.shadowRoot.querySelector("iframe");
          var player = new Vimeo.Player(videoIframe);
          player.pause();
        }
      }
    }
  });
};
